// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x9Rp1K96XwkZFVj4{display:flex;flex-direction:column;height:100%}.WUsOBvSAQAMnLqvs{padding:24px;height:100%;overflow:auto}.WUsOBvSAQAMnLqvs .VtiGjDBzZ9MNQnJv{display:flex;justify-content:space-between;align-items:center;padding-bottom:24px}.XEK2i70VZOknNe1f{width:100%;padding:24px;background-color:#fff;box-sizing:border-box}.XEK2i70VZOknNe1f .o8Cwf7v6owjQVzhZ{width:100%;box-sizing:border-box}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filtersContainer": `x9Rp1K96XwkZFVj4`,
	"filters": `WUsOBvSAQAMnLqvs`,
	"headerRow": `VtiGjDBzZ9MNQnJv`,
	"applyFiltersButtonContainer": `XEK2i70VZOknNe1f`,
	"applyButton": `o8Cwf7v6owjQVzhZ`
};
export default ___CSS_LOADER_EXPORT___;
